module.exports = __webpack_public_path__ + "img/code4.c2273507.png";